var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidecart" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.sidecartOpen
          ? _c("div", {
              staticClass: "sidecart__overlay",
              on: {
                click: function($event) {
                  return _vm.$store.dispatch("cart/closeSidecart")
                }
              }
            })
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "off-canvas-right" } }, [
        _vm.sidecartOpen
          ? _c("div", { staticClass: "sidecart__drawer" }, [
              _c("div", { staticClass: "sidecart__header" }, [
                _c(
                  "div",
                  { staticClass: "sidecart__header-content" },
                  [
                    _c("div", { staticClass: "sidecart__count" }, [
                      _vm._v(_vm._s(_vm.cartCountText))
                    ]),
                    _c(
                      "h2",
                      {
                        ref: "sidecartHeading",
                        staticClass: "sidecart__title",
                        attrs: { tabindex: 0 }
                      },
                      [_vm._v(_vm._s(_vm.heading))]
                    ),
                    _c(
                      "base-button",
                      {
                        staticClass: "button--icon sidecart__close",
                        on: {
                          click: function($event) {
                            return _vm.$store.dispatch("cart/closeSidecart")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "u-sr-only" }, [
                          _vm._v("Close side cart")
                        ]),
                        _c("icon", {
                          staticClass: "button__icon",
                          attrs: { name: "close", size: "20px" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "sidecart__container" }, [
                _vm.cartData.item_count > 0
                  ? _c(
                      "div",
                      {
                        key: "content",
                        staticClass: "sidecart__contents-wrapper"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "sidecart__contents" },
                          _vm._l(_vm.cartData.items, function(item, index) {
                            return _c("cart-line-item", {
                              key: item.id,
                              attrs: { item: item, line: index + 1 }
                            })
                          }),
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sidecart__footer" },
                          [
                            _c("cart-totals-table"),
                            _c(
                              "base-button",
                              {
                                staticClass:
                                  "button--full-width sidecart__checkout-cta",
                                attrs: { full: true, href: _vm.checkoutURL }
                              },
                              [_vm._v("Checkout")]
                            ),
                            _vm.promoMessage
                              ? _c("div", {
                                  staticClass: "sidecart__promo",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.promoMessage)
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  : _c(
                      "div",
                      { key: "empty", staticClass: "sidecart__empty" },
                      [
                        _c("p", { staticClass: "sidecart__empty-text" }, [
                          _vm._v(_vm._s(_vm.emptyText))
                        ]),
                        _vm.emptyCartCtaUrl && _vm.emptyCartCtaText
                          ? _c(
                              "base-button",
                              {
                                staticClass: "sidecart__empty-cta",
                                attrs: { href: _vm.emptyCartCtaUrl }
                              },
                              [_vm._v(_vm._s(_vm.emptyCartCtaText))]
                            )
                          : _vm._e(),
                        _vm.emptyCartSecondaryCtaUrl &&
                        _vm.emptyCartSecondaryCtaText
                          ? _c(
                              "base-button",
                              {
                                staticClass:
                                  "sidecart__empty-cta sidecart__empty-cta--secondary button--green",
                                attrs: { href: _vm.emptyCartSecondaryCtaUrl }
                              },
                              [_vm._v(_vm._s(_vm.emptyCartSecondaryCtaText))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }